import { SAVE_USERINFO, DELETE_USERINFO } from '../constant'

let user = JSON.parse(localStorage.getItem('user'))
// let menus = JSON.parse(localStorage.getItem('menus'))
let token = localStorage.getItem('token')

const initState = {
  user: user || {},
  // menus: menus || {},
  token: token || '',
  isLogin: user && token ? true : false
}
export default function loginReducer(preState = initState, action) {
  const { type, data } = action
  let newState
  switch (type) {
    case SAVE_USERINFO:
      // newState = { user: data.ds[0], menus: data.ds[1], token: data.token, isLogin: true }
      newState = { user: data.ds[0], token: data.token, isLogin: true }
      return newState
    case DELETE_USERINFO:
      newState = { user: {}, menus: {}, token: '', isLogin: false }
      return newState

    default:
      return preState
  }
}